// ============================================================
// MEDIA MAP — generated dari folder Google Drive Kin.
// M(slug, ids, caps) → array foto  /media/<slug>/img-XX.webp
// V(slug, ids, caps) → array video /media/<slug>/vid-XX.mp4 (+ poster .jpg)
// ids: angka (jumlah) atau array nomor file.
// Untuk menambah media baru: taruh file di public/media/<slug>/ lalu
// tambahkan id-nya di sini.
// ============================================================

const pad = (n) => String(n).padStart(2, "0");
const idsOf = (ids, exclude = []) =>
  (Array.isArray(ids) ? ids : Array.from({ length: ids }, (_, i) => i + 1)).filter((n) => !exclude.includes(n));

export const M = (slug, ids, caps = {}, exclude = []) =>
  idsOf(ids, exclude).map((n) => ({
    src: `/media/${slug}/img-${pad(n)}.webp`,
    caption: caps[n] || "",
    slot: `${slug.toUpperCase()}_IMAGE_${pad(n)}`,
  }));

export const V = (slug, ids, caps = {}, exclude = []) =>
  idsOf(ids, exclude).map((n) => ({
    src: `/media/${slug}/vid-${pad(n)}.mp4`,
    poster: `/media/${slug}/vid-${pad(n)}.jpg`,
    caption: caps[n] || "",
    slot: `${slug.toUpperCase()}_VIDEO_${pad(n)}`,
  }));
